import { CSSProperties, forwardRef } from 'react';
import { Badge } from 'react-bootstrap';
import { Button } from '@praktio/common-ui';
import classNames from 'classnames';

import ReportNotification from '../ReportNotification';

import './SettingsMenu.scss';

interface IMenuProps {
  style?: CSSProperties;
  className?: string;
  'aria-labelledby'?: string;
  notification?: IReportNotification;
  hasChanges: boolean;
  savedChanges: boolean;
  noNotification?: boolean;
  isSaving?: boolean;
  onNotificationChange: (value?: string, prop?: string) => void;
  onSaveClick: () => void;
}

const SettingsMenu = forwardRef<HTMLDivElement, IMenuProps>(
  (
    {
      style,
      className,
      'aria-labelledby': labeledBy,
      notification,
      hasChanges,
      savedChanges,
      noNotification,
      isSaving,
      onNotificationChange,
      onSaveClick,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        style={style}
        className={classNames(className, 'ReportSettings-menu')}
        aria-labelledby={labeledBy}
      >
        <div className="ReportSettings-header">
          {!!hasChanges && (
            <Badge pill className="changes-badge">
              Unsaved Changes
            </Badge>
          )}

          {!!savedChanges && (
            <div className="saved-changes">
              <span className="material-icons save-check">done</span>Saved!
            </div>
          )}

          <Button disabled={!hasChanges || isSaving} showSpinner={isSaving} onClick={onSaveClick}>
            SAVE
          </Button>
        </div>

        <div className="ReportSettings-content">
          {!noNotification && (
            <ReportNotification notification={notification} onChange={onNotificationChange} />
          )}
        </div>
      </div>
    );
  },
);

export default SettingsMenu;
